import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./RechargeLinesUIHelpers";

const RechargeLinesUIContext = createContext();

export function useRechargeLinesUIContext() {
  return useContext(RechargeLinesUIContext);
}

export const RechargeLinesUIConsumer = RechargeLinesUIContext.Consumer;

export function RechargeLinesUIProvider({ rechargeLinesUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openUpdateRechargeLinesStatusDialog:
      rechargeLinesUIEvents.openUpdateRechargeLinesStatusDialog,
  };

  return (
    <RechargeLinesUIContext.Provider value={value}>
      {children}
    </RechargeLinesUIContext.Provider>
  );
}
